//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {HeadBar, BingMap, HotelFilter, HotelSearch, PopupCalendar} from '@/components';
import HotelBox from './components/HotelBox';
import utils from "@/utils/utils";
import {HotelSearchProxy} from "@/http/RequestProxy.class";

const searchProxy = new HotelSearchProxy();
export default {
  name: 'hotel-map',
  components: {
    HeadBar,
    BingMap,
    HotelBox,
    HotelFilter,
    HotelSearch,
    PopupCalendar,
  },
  data(){
    return {
      isShowFilter: false,
      isShowHotel: false,
      isShowHotelSearch: false,
      isShowCalendar: false,
      beginDateForArr: [],
      endDateForArr: [],
      query: {

      },
      latLngData: [],
      total: 20,
      hotelInfo: {},
      // 筛选条件
      filterConditions: [],
    };
  },
  computed: {
    lanType(){
      return +window.localStorage.getItem('lan_type');
    },
  },
  // created(){
  //   utils.setBodyStyle({height: '100%'});
  //   this.query = this.$route.query;
  //
  //   this.beginDateForArr = this.query.date_from.split('-');
  //   this.endDateForArr = this.query.date_to.split('-');
  //   // 酒店列表进入地图列表，请求酒店列表数据
  //   if(!this.query.is_unit_hotel){
  //     this.getHotelData();
  //   }else{  // 酒店详情页路由到地图页面
  //     let hash = {
  //       latitude: this.query.lat,
  //       longitude: this.query.lng,
  //     };
  //
  //     this.query.is_unit_hotel = Boolean(this.query.is_unit_hotel);
  //     this.latLngData.push(hash);
  //   }
  // },
  mounted(){
    utils.setBodyStyle({height: '100%'});
    this.query = this.$route.query;

    this.beginDateForArr = this.query.date_from.split('-');
    this.endDateForArr = this.query.date_to.split('-');
    // 酒店列表进入地图列表，请求酒店列表数据
    if(!this.query.is_unit_hotel){
      // setTimeout(() => {
      //   this.getHotelData();
      // }, 1000);
      // this.total = this.query.total
      let list = JSON.parse(localStorage.getItem('hotelMarkList'))
      
      
      this.total = list.total
      this.latLngData = list.hotel
      
    }else{  // 酒店详情页路由到地图页面
      let hash = {
        latitude: this.query.lat,
        longitude: this.query.lng,
      };

      this.query.is_unit_hotel = Boolean(this.query.is_unit_hotel);
      this.latLngData.push(hash);
    }
  },
  beforeDestroy(){
    utils.setBodyStyle({height: 'auto'});
  },
  methods: {
    getHotelData(){
      searchProxy.getHotelList(this.query)
        .then(resp => {
          if(resp){
            this.latLngData = resp.data.hotel;
            this.total = resp.data.total;
            // this.$refs.hotelBox.hideBox();
          }
        });
    },

    /** 获取数据下标值 */
    onGetHotelIndex(index){
      this.hotelInfo = this.latLngData[index];
    },

    /** 筛选酒店 */
    onFilterHotel(params){
      this.filterConditions = params.conditionsHash;
      this.query = Object.assign({}, this.query, params.filterParams);
      this.query.page = 1;

      setTimeout(() => {
        this.getHotelData();
      }, 200);
    },

    /** 获取搜索内容 */
    onGetRegion(resp){
      this.query.region_id = resp.region_id;
      this.query.hotel_id = resp.hotel_id;
      this.query.region_name = resp.name;
      this.query.page = 1;
      this.latLngData = [];
      this.getHotelData();
    },

    /** 获取日期 */
    onGetDate(resp){
      const {start, end} = utils.combineDateFromArr(resp.start, resp.end);

      this.query.date_from = start;
      this.query.date_to = end;
      this.query.page = 1;
      this.latLngData = [];
      this.getHotelData();
    },

    /** 跳转到详情页 */
    onLinkToDetail(resp){
      let req;

      if(this.query.is_unit_hotel){
        req = {
          hotel_id: this.query.hotel_id,
          start_date: this.query.date_from,
          end_date: this.query.date_to,
        };
      }else{
        req = {
          hotel_id: resp.hotel_id,
          start_date: this.query.date_from,
          end_date: this.query.date_to,
        };
      }

      this.$router.push({name: 'hotel-detail', params: req});
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/map/hotel-map.vue